"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _GroupList = _interopRequireDefault(require("./GroupList"));

var _Group = _interopRequireDefault(require("./Group"));

var _FilterBar = _interopRequireDefault(require("./FilterBar"));

var _DisplayFilter = _interopRequireDefault(require("./DisplayFilter"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-height: ", ";\n\toverflow-y: ", ";\n\tmargin: ", " 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight === 'none' ? 'none' : maxHeight + "px";
}, function (_ref2) {
  var hideScrollbar = _ref2.hideScrollbar;
  return hideScrollbar ? 'hidden' : "scroll";
}, _spacing.default.s1);

Container.displayName = 'Container';

var EmployeePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EmployeePicker, _React$Component);

  function EmployeePicker() {
    var _this;

    _this = _React$Component.call(this) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.state = {
      type: 'name',
      filter: ''
    };
    return _this;
  }

  var _proto = EmployeePicker.prototype;

  _proto.onItemClick = function onItemClick(id) {
    var toggleUsers = this.props.toggleUsers;
    toggleUsers([id]);
  };

  _proto.deselectAll = function deselectAll() {
    var _this$props = this.props,
        toggleUsers = _this$props.toggleUsers,
        users = _this$props.users;
    toggleUsers((0, _utils.getSelected)(users).filter(_utils.filterDisabled).map(_utils.idMap));
  };

  _proto.selectAll = function selectAll() {
    var _this$props2 = this.props,
        toggleUsers = _this$props2.toggleUsers,
        users = _this$props2.users;
    toggleUsers((0, _utils.getNotSelected)(users).filter(_utils.filterDisabled).map(_utils.idMap));
  };

  _proto.updateFilter = function updateFilter(filter) {
    this.setState({
      filter: filter
    });
  };

  _proto.updateType = function updateType(type) {
    this.setState({
      type: type,
      filter: ''
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        users = _this$props3.users,
        groupBy = _this$props3.groupBy,
        toggleUsers = _this$props3.toggleUsers,
        maxHeight = _this$props3.maxHeight,
        hideScrollbar = _this$props3.hideScrollbar,
        GA = _this$props3.GA,
        hideSelectAll = _this$props3.hideSelectAll,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["users", "groupBy", "toggleUsers", "maxHeight", "hideScrollbar", "GA", "hideSelectAll"]);

    var _this$state = this.state,
        filter = _this$state.filter,
        type = _this$state.type;
    var selectedUsers = (0, _utils.getSelected)(users);
    var groups = (0, _utils.buildGroups)(users, groupBy);
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_FilterBar.default, {
      value: filter,
      type: type,
      update: this.updateFilter,
      updateType: this.updateType,
      selectAll: this.selectAll,
      deselectAll: this.deselectAll,
      disableSelect: selectedUsers.length === users.length,
      disableDeselect: selectedUsers.length === 0,
      GA: GA,
      hideSelectAll: hideSelectAll
    }), _react.default.createElement(Container, _extends({
      "data-testid": "results",
      maxHeight: maxHeight,
      hideScrollbar: hideScrollbar
    }, rest), !filter && _react.default.createElement(_Group.default, {
      GA: GA,
      title: "Selected",
      users: selectedUsers,
      onClick: this.onItemClick,
      hideButtons: true,
      initialShow: false,
      toggleUsers: toggleUsers
    }), filter && type === 'name' ? _react.default.createElement(_DisplayFilter.default, {
      users: users,
      filter: filter,
      onClick: this.onItemClick
    }) : _react.default.createElement(_GroupList.default, {
      GA: GA,
      groups: groups,
      toggleUsers: toggleUsers,
      onItemClick: this.onItemClick,
      filter: filter
    })));
  };

  return EmployeePicker;
}(_react.default.Component);

EmployeePicker.displayName = 'EmployeePicker';
EmployeePicker.propTypes = {
  GA: (0, _propTypes.shape)({
    category: _propTypes.string
  }).isRequired,
  users: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
    firstName: _propTypes.string.isRequired,
    lastName: _propTypes.string.isRequired,
    selected: _propTypes.bool.isRequired
  })),
  toggleUsers: _propTypes.func.isRequired,
  groupBy: _propTypes.string,

  /** any number or none */
  maxHeight: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.oneOf)(['none'])]),
  hideScrollbar: _propTypes.bool,
  hideSelectAll: _propTypes.bool
};
EmployeePicker.defaultProps = {
  users: [],
  groupBy: undefined,
  maxHeight: 700,
  hideScrollbar: false,
  hideSelectAll: false
};
var _default = EmployeePicker;
exports.default = _default;